/*
 * @Author: 晋枫
 * @Date: 2021-09-16 10:16:47
 * @LastEditTime: 2021-10-15 15:46:31
 * @LastEditors: gaochen
 * @Description: 工作台V2路由定义
 * @FilePath: /jmj-7v1-task/src/router/modules/bulletinBoard/workbenchV2.js
 * 🍁YOU CAN（NOT）REDO🍁
 */
import { routeAddWorkOrderId, WORK_ORDER_TYPES } from '@/views/wxapp/bulletin-board/workbench-v2/constant'

const workbenchRouter = [
  {
    path: 'dashboard-workbench',
    name: 'DashboardWorkbench',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/index.vue'),
    meta: {
      title: '工作台'
    }
  },
  {
    path: 'work-order-home',
    name: 'WorkOrderHome',
    // component: () => import('@/views/wxapp/bulletin-board/workbench-v2/WorkOrderHome'),
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/managementOrder'),
    meta: {
      title: '工作台'
    }
  },
  {
    path: 'work-order-detail',
    name: 'WorkOrderDetail',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/WorkOrderDetail'),
    meta: {
      title: '工单详情'
    }
  },
  {
    path: 'create-work-order',
    name: 'CreateWorkOrder',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/CreateWorkOrder/index.vue'),
    meta: {
      title: '创建工单'
    }
  },
  {
    path: 'respond-work-order',
    name: 'RespondWorkOrder',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/ProcessWorkOrder/index.vue'),
    meta: {
      title: '响应工单'
    }
  },
  {
    path: 'add-work-order-process',
    name: 'AddWorkOrderProcess',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/ProcessWorkOrder/index.vue'),
    meta: {
      title: '处理过程'
    }
  },
  {
    path: 'finish-work-order',
    name: 'FinishWorkOrder',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/ProcessWorkOrder/index.vue'),
    meta: {
      title: '完成工单'
    }
  },
  {
    path: 'child-order-list',
    name: 'ChildOrderList',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/ChildOrder/ChildOrderList'),
    meta: {
      title: '创建/关联工单'
    }
  },
  {
    path: 'success-order',
    name: 'SuccessOrder',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/common/SuccessOrder.vue'),
    meta: {
      title: '提交成功'
    }
  },
  {
    path: 'process-work-order-details',
    name: 'ProcessWorkOrderDetails',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/ProcessWorkOrderDetails'),
    meta: {
      title: '处理过程'
    }
  },
  {
    path: 'reject-page',
    name: 'RejectPage',
    component: () => import('@/views/wxapp/bulletin-board/workbench-v2/WorkOrderDetail/components/RejectPage'),
    meta: {
      title: '驳回方案'
    }
  }
]

export default routeAddWorkOrderId(workbenchRouter, WORK_ORDER_TYPES.OPERATE)
